import React, { useEffect, useState } from 'react';

type Props = {
  children: JSX.Element[];
  classes: string;
  showAll: boolean;
  initialCount: number;
};

function ShowMore({ children, classes, initialCount, showAll }: Props) {
  const [visibleCount, setVisibleCount] = useState(initialCount);

  useEffect(() => {
    if (showAll) {
      setVisibleCount(React.Children.count(children));
    } else {
      setVisibleCount(initialCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAll]);

  return <div className={classes}>{React.Children.toArray(children).slice(0, visibleCount)}</div>;
}

export default ShowMore;
